// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__7nyz_","LoginForm":"Login_LoginForm__2xZ7Y","ValidationError":"Login_ValidationError__1wWet"};